// extracted by mini-css-extract-plugin
export default {"page-choice-panel":"DeXuatDanhGiaTrangTri_page-choice-panel__zFvGw"};